import React from "react";
import ReactDOM from "react-dom/client";
import { installBrowserPrivacyBoundary } from "./browserPrivacy.js";
import App from "./AuthenticatedApp.jsx";
import "./index.css";

// Browser UI availability is separate from server-side API authorization.
// No secret is embedded and no API authentication boundary is disabled here.
installBrowserPrivacyBoundary(window);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
